import { createSlice } from '@reduxjs/toolkit'

type BulDetails = {
  bulkServiceId: string,
  selectedTemplate: {
    bank: boolean,
    wallet: boolean,
    bill: boolean,
  },
  clientBulkPayload?: {
    name: string,
    categoryId: string,
    bulkServiceId: string,
    debitAccount: string,
    debitAccountNames: string,
    debitCurrency: string,
    customerNumber: string,
    narration: string,
    debitType: string,
    clearingAccountId?: {
      customerNumber: string,
      currency: string,
      clearingAccount: string,
    },
  },
}

const initialState: BulDetails = {
  bulkServiceId: '',
  selectedTemplate: {
    bank: false,
    wallet: false,
    bill: false,
  },
  clientBulkPayload: {
    name: '',
    categoryId: '',
    bulkServiceId: '',
    debitAccount: '',
    debitAccountNames: '',
    debitCurrency: '',
    customerNumber: '',
    narration: '',
    debitType: '',
    clearingAccountId: {
      customerNumber: '',
      currency: '',
      clearingAccount: '',
    }
  }
}

const BulkPayments = createSlice({
  name: 'bulkPayments',
  initialState,
  reducers: {
    setBulkServiceId: (state, action) => {
      state.bulkServiceId = action.payload
    },
    setClientBulkPayload: (state, action) => {
      state.clientBulkPayload = action.payload
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload
    },
    clearSelectedTemplate: (state) => {
      state.selectedTemplate = {
        bank: false,
        wallet: false,
        bill: false,
      }
    },
    clearClientBulkPayload: (state) => {
      state.clientBulkPayload = initialState.clientBulkPayload}
  },
})

export const { 
  setBulkServiceId, 
  setClientBulkPayload, 
  setSelectedTemplate,
  clearSelectedTemplate,
  clearClientBulkPayload 
} = BulkPayments.actions
export const getBulkDetails = (state: { bulkPayments: BulDetails, }) => state.bulkPayments
export const getBulkSelectedTemplate = (state: { bulkPayments: BulDetails, }) => state.bulkPayments.selectedTemplate
export default BulkPayments.reducer